import type { CameraFrame } from '../../scene/SkyCamera';

export const fieldOfViewRange = (
  camera: CameraFrame,
  bearing: number,
  ticksPerTurn: number,
  aspect: number
) => {
  const verticalFov = (camera.fov * Math.PI) / 180;
  const horizontalFov =
    (2 * Math.atan(Math.tan(verticalFov / 2) * aspect) * 180) / Math.PI;
  const cameraBearing = 270 - (camera.yaw * 180) / Math.PI;
  const center = ((((cameraBearing - bearing + 180) % 360) + 360) % 360) - 180;
  const ticksPerDegree = ticksPerTurn / 360;

  return {
    start: (center - horizontalFov / 2) * ticksPerDegree,
    end: (center + horizontalFov / 2) * ticksPerDegree,
  };
};
